var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "cross_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#inherit",
  d: "m19.73 18.251-6.31-6.27 6.27-6.31a.996.996 0 1 0-1.41-1.41l-6.27 6.31-6.33-6.28a.996.996 0 1 0-1.41 1.41l6.31 6.27-6.27 6.31a.996.996 0 0 0 0 1.41c.2.19.45.29.71.29s.51-.1.71-.29l6.27-6.31 6.31 6.27c.2.19.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41z"
})));
export default SvgCross;